export const NUMBER_KINGDOM_ASSETS = {
  arrivalBackground: {
    key: 'number-kingdom-arrival-background',
    path: 'assets/number-kingdom/backgrounds/arrival-valley-bg.png',
  },
  arrivalPlaza: {
    key: 'number-kingdom-arrival-plaza',
    path: 'assets/number-kingdom/environments/arrival-plaza.png',
  },
  foregroundFoliageLeft: {
    key: 'number-kingdom-foreground-foliage-left',
    path: 'assets/number-kingdom/environments/foreground-foliage-left.png',
  },
  foregroundFoliageRight: {
    key: 'number-kingdom-foreground-foliage-right',
    path: 'assets/number-kingdom/environments/foreground-foliage-right.png',
  },
  starBridgeBroken: {
    key: 'number-kingdom-star-bridge-broken',
    path: 'assets/number-kingdom/star-bridge/star-bridge-broken.png',
  },
  starBridgeRepair1: {
    key: 'number-kingdom-star-bridge-repair-1',
    path: 'assets/number-kingdom/star-bridge/star-bridge-repair-1.png',
  },
  starBridgeRepair2: {
    key: 'number-kingdom-star-bridge-repair-2',
    path: 'assets/number-kingdom/star-bridge/star-bridge-repair-2.png',
  },
  starBridgeRepair3: {
    key: 'number-kingdom-star-bridge-repair-3',
    path: 'assets/number-kingdom/star-bridge/star-bridge-repair-3.png',
  },
  starBridgeRestored: {
    key: 'number-kingdom-star-bridge-restored',
    path: 'assets/number-kingdom/star-bridge/star-bridge-restored.png',
  },
  numberKingdomTitle: {
    key: 'number-kingdom-title',
    path: 'assets/number-kingdom/ui/number-kingdom-title.png',
  },
  homeHubButtonFrame: {
    key: 'number-kingdom-home-hub-button-frame',
    path: 'assets/number-kingdom/ui/home-hub-button-frame.png',
  },
  starBridgeMissionPanel: {
    key: 'number-kingdom-star-bridge-mission-panel',
    path: 'assets/number-kingdom/ui/star-bridge-mission-panel.png',
  },
  arrivalMagic: {
    key: 'number-kingdom-arrival-magic',
    path: 'assets/number-kingdom/vfx/arrival-magic.png',
  },
  bridgeMagicGlow: {
    key: 'number-kingdom-bridge-magic-glow',
    path: 'assets/number-kingdom/vfx/bridge-magic-glow.png',
  },
  numberKingdomCosmo: {
    key: 'number-kingdom-cosmo',
    path: 'assets/shared/cosmo/cosmo-number-kingdom.png',
  },
  numberBuilderConsole: {
    key: 'number-kingdom-number-builder-console',
    path: 'assets/number-kingdom/interactives/number-builder-console.png',
  },
  hundredBlock: {
    key: 'number-kingdom-hundred-block',
    path: 'assets/number-kingdom/interactives/hundred-block.png',
  },
  tenRod: {
    key: 'number-kingdom-ten-rod',
    path: 'assets/number-kingdom/interactives/ten-rod.png',
  },
  oneCube: {
    key: 'number-kingdom-one-cube',
    path: 'assets/number-kingdom/interactives/one-cube.png',
  },
  hundredsSlot: {
    key: 'number-kingdom-hundreds-slot',
    path: 'assets/number-kingdom/interactives/hundreds-slot.png',
  },
  tensSlot: {
    key: 'number-kingdom-tens-slot',
    path: 'assets/number-kingdom/interactives/tens-slot.png',
  },
  onesSlot: {
    key: 'number-kingdom-ones-slot',
    path: 'assets/number-kingdom/interactives/ones-slot.png',
  },
  challengePanel: {
    key: 'number-kingdom-challenge-panel',
    path: 'assets/number-kingdom/ui/challenge-panel.png',
  },
  checkAnswerButton: {
    key: 'number-kingdom-check-answer-button',
    path: 'assets/number-kingdom/ui/check-answer-button.png',
  },
  hintButton: {
    key: 'number-kingdom-hint-button',
    path: 'assets/number-kingdom/ui/hint-button.png',
  },
  numberEnergyOrb: {
    key: 'number-kingdom-number-energy-orb',
    path: 'assets/number-kingdom/vfx/number-energy-orb.png',
  },
  correctBurst: {
    key: 'number-kingdom-correct-burst',
    path: 'assets/number-kingdom/vfx/correct-burst.png',
  },
  incorrectPulse: {
    key: 'number-kingdom-incorrect-pulse',
    path: 'assets/number-kingdom/vfx/incorrect-pulse.png',
  },
  bridgeEnergyBeam: {
    key: 'number-kingdom-bridge-energy-beam',
    path: 'assets/number-kingdom/vfx/bridge-energy-beam.png',
  },
  numberPathPlatform: {
    key: 'number-kingdom-number-path-platform',
    path: 'assets/number-kingdom/interactives/number-path-platform.png',
  },
  numberPathNode: {
    key: 'number-kingdom-number-path-node',
    path: 'assets/number-kingdom/interactives/number-path-node.png',
  },
  numberPathNodeActive: {
    key: 'number-kingdom-number-path-node-active',
    path: 'assets/number-kingdom/interactives/number-path-node-active.png',
  },
  jumpPlusTen: {
    key: 'number-kingdom-jump-plus-ten',
    path: 'assets/number-kingdom/interactives/jump-plus-10.png',
  },
  jumpPlusOne: {
    key: 'number-kingdom-jump-plus-one',
    path: 'assets/number-kingdom/interactives/jump-plus-1.png',
  },
  numberPathEnergyOrb: {
    key: 'number-kingdom-number-path-energy-orb',
    path: 'assets/number-kingdom/interactives/number-path-energy-orb.png',
  },
  pathFinishCrystal: {
    key: 'number-kingdom-path-finish-crystal',
    path: 'assets/number-kingdom/interactives/path-finish-crystal.png',
  },
  numberPathChallengePanel: {
    key: 'number-kingdom-number-path-challenge-panel',
    path: 'assets/number-kingdom/ui/number-path-challenge-panel.png',
  },
  numberPathHintButton: {
    key: 'number-kingdom-number-path-hint-button',
    path: 'assets/number-kingdom/ui/number-path-hint-button.png',
  },
  numberPathResetButton: {
    key: 'number-kingdom-number-path-reset-button',
    path: 'assets/number-kingdom/ui/number-path-reset-button.png',
  },
  numberPathJumpTrail: {
    key: 'number-kingdom-number-path-jump-trail',
    path: 'assets/number-kingdom/vfx/number-path-jump-trail.png',
  },
  numberPathSuccessBurst: {
    key: 'number-kingdom-number-path-success-burst',
    path: 'assets/number-kingdom/vfx/number-path-success-burst.png',
  },
  bridgeEnergyBeam2: {
    key: 'number-kingdom-bridge-energy-beam-2',
    path: 'assets/number-kingdom/vfx/bridge-energy-beam-2.png',
  },
  numberCoreMachine: {
    key: 'number-kingdom-number-core-machine',
    path: 'assets/number-kingdom/interactives/number-core-machine.png',
  },
  numberCoreBroken: {
    key: 'number-kingdom-number-core-broken',
    path: 'assets/number-kingdom/interactives/number-core-broken.png',
  },
  numberCorePowered: {
    key: 'number-kingdom-number-core-powered',
    path: 'assets/number-kingdom/interactives/number-core-powered.png',
  },
  repairHundredControl: {
    key: 'number-kingdom-repair-hundred-control',
    path: 'assets/number-kingdom/interactives/repair-hundred-control.png',
  },
  repairTenControl: {
    key: 'number-kingdom-repair-ten-control',
    path: 'assets/number-kingdom/interactives/repair-ten-control.png',
  },
  repairOneControl: {
    key: 'number-kingdom-repair-one-control',
    path: 'assets/number-kingdom/interactives/repair-one-control.png',
  },
  coreEnergyCrystal: {
    key: 'number-kingdom-core-energy-crystal',
    path: 'assets/number-kingdom/interactives/core-energy-crystal.png',
  },
  numberCoreChallengePanel: {
    key: 'number-kingdom-number-core-challenge-panel',
    path: 'assets/number-kingdom/ui/number-core-challenge-panel.png',
  },
  numberCoreRepairButton: {
    key: 'number-kingdom-number-core-repair-button',
    path: 'assets/number-kingdom/ui/number-core-repair-button.png',
  },
  numberCoreHintButton: {
    key: 'number-kingdom-number-core-hint-button',
    path: 'assets/number-kingdom/ui/number-core-hint-button.png',
  },
  numberCoreResetButton: {
    key: 'number-kingdom-number-core-reset-button',
    path: 'assets/number-kingdom/ui/number-core-reset-button.png',
  },
  coreErrorPulse: {
    key: 'number-kingdom-core-error-pulse',
    path: 'assets/number-kingdom/vfx/core-error-pulse.png',
  },
  coreRepairBurst: {
    key: 'number-kingdom-core-repair-burst',
    path: 'assets/number-kingdom/vfx/core-repair-burst.png',
  },
  bridgeEnergyBeam3: {
    key: 'number-kingdom-bridge-energy-beam-3',
    path: 'assets/number-kingdom/vfx/bridge-energy-beam-3.png',
  },
  finalBridgeRestorationBurst: {
    key: 'number-kingdom-final-bridge-restoration-burst',
    path: 'assets/number-kingdom/vfx/final-bridge-restoration-burst.png',
  },
} as const;

export const NUMBER_KINGDOM_ASSET_LIST = Object.values(NUMBER_KINGDOM_ASSETS);
